import { Typography, Button, Input, Form, Layout, Card, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import * as Validation from "../../../utils/helper/validation";
import * as APIS from "../../../utils/helper/enum";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import globalRequest from "../../../utils/global/globalRequest";
import { changeTrigger } from "../../../redux/reducers/trigger";
import toast from "react-hot-toast";
const { Title } = Typography;
const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();  
  const [apiError, setApiError] = useState({});
  const [form] = Form.useForm();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
    setApiError((prevError) => ({
      ...prevError,
      [name]: undefined, // Clear the error for the field
    }));
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.ONBOARDING_APIS?.FORGOT_PASSWORD,
        "post",
        values
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        dispatch(changeTrigger("loggedin"));
        let msg = "link sent on your email please check your inbox.";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/");
      } else {
        setApiError({ email: apiResponse.message });
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Flex
          gap="middle"
          align="center"
          justify="center"
          vertical
          style={{
            minHeight: "100vh",
            padding: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            className="relative"
            style={{
              width: "100%",
              maxWidth: 500,
              boxSizing: "border-box",
              ...(window.innerWidth < 768 ? { width: "100%" } : {}),
            }}
          >
            <img
              width={170}
              src="logo.svg"
              alt=""
              className="mx-auto absolute top-[-70px] left-0 right-0"
            />
            <Title level={3} align={"center"}>
              Forgot Password
            </Title>
            <div className="text-[15px] font-normal">
              Enter registered email address to receive reset password link
            </div>
            <Form
              name="login"
              layout="vertical"
              onFinish={handleSubmit}
              style={{
                width: "100%",
                marginTop: 24,
              }}
            >
              <Form.Item
                label="Email Address"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address.",
                  },
                ]}
                help={apiError && apiError.email}
                validateStatus={apiError && apiError.email ? "error" : ""}
                validateTrigger={"onSubmit"}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("email", value);
                    handleInputChange("email");
                  }}
                  placeholder="Please Enter Your Email"
                />
              </Form.Item>

              <div className="flex gap-4">
                <Button
                  className="w-full mt-4"
                  size="large"
                  type="primary outline-btn"
                  htmlType="submit"
                  onClick={() => navigate("/")}
                >
                  Back
                </Button>
                <Button
                  className="w-full mt-4"
                  size="large"
                  type="primary"
                  htmlType="submit"
                  onClick={() => form.submit()}
                >
                  Send Link
                </Button>
              </div>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  );
};

export default ForgotPassword;
